import { render, staticRenderFns } from "./WaitReadTask.vue?vue&type=template&id=181dc725&scoped=true"
import script from "./WaitReadTask.vue?vue&type=script&lang=js"
export * from "./WaitReadTask.vue?vue&type=script&lang=js"
import style0 from "./WaitReadTask.vue?vue&type=style&index=0&id=181dc725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181dc725",
  null
  
)

export default component.exports